import { render, staticRenderFns } from "./folderArrowLeftRight.vue?vue&type=template&id=6c989742"
import script from "./folderArrowLeftRight.vue?vue&type=script&lang=js"
export * from "./folderArrowLeftRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports